import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@ui/styles.js'
import 'leaflet/dist/leaflet.css'
import './index.css'
import App from './App.jsx'
import { followSystemTheme } from './theme.js'
import { startErrorReporting } from './errorReporting.js'
import { AuthProvider } from './auth.jsx'
import { UnitProvider } from './units.jsx'

followSystemTheme()
startErrorReporting()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <UnitProvider>
          <App />
        </UnitProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
